module.exports = __webpack_public_path__ + "static/stb_message-structure-493866b83447a530d0dcd31af30e5953.jpg";